const paths = {
  whatsapp: '/whatsapp'
};

// Páginas donde el MiniChatDock está disponible (productId === 3)
export const MINI_CHAT_ALLOWED_PATHS = ['/console', '/listProtocol', '/reportConsole'];

export default paths;
